import { Pipe, PipeTransform } from '@angular/core';
import {FormGroup} from "@angular/forms";
import {TranslocoService} from "@ngneat/transloco";
import {Observable} from "rxjs";
import {UntilDestroy} from "@ngneat/until-destroy";
import {map} from "rxjs/operators";

@UntilDestroy()
@Pipe({
    name: 'errorControl',
    standalone: false
})
export class ErrorControlPipe implements PipeTransform {

  constructor(private transloco: TranslocoService) {}

  transform(form: FormGroup, formControlName: string): Observable<string> {
    return form.valueChanges.pipe(
      map((_) => {
        const control = form.controls[formControlName];
        const errorString = Object.keys(control.errors ? control.errors: {}).find(error => control.errors ? control.errors[error] : false);
        if (!errorString) {
          return ''
        }
        return `${this.transloco.translate(`FORM.ERRORS.${errorString.toUpperCase()}`)}`
      })
    )
  }

}
